import {
  getJson, postJson, putJson,
} from '../../http/cloud-backend-infrastructure';

export const createPartner = (data) => postJson('/api/v1.0/partner', data);

export const getSalesSteps = () => getJson('/api/v1.0/partner/sales-steps');

export const getOfficeTypes = () => getJson('/api/v1.0/partner/office-types');

export const getInvoiceTypes = () => getJson('/api/v1.0/partner/invoice-types');

export const getOriginTypes = () => getJson('/api/v1.0/partner/origin-types');

export const getFieldOptions = async () => {
  const [officeData, invoiceData, originData] = await Promise.all([
    getOfficeTypes(),
    getInvoiceTypes(),
    getOriginTypes(),
  ]);
  const { officeTypes } = officeData;
  const { invoiceTypes } = invoiceData;
  const { originTypes } = originData;
  return {
    officeTypes, invoiceTypes, originTypes,
  };
};

export const saveGeneralInformation = (partnerId, data) => putJson(`/api/v1.0/partner/${partnerId}/general-information`, data);

export const saveOnBoardingInformation = (partnerId, data) => putJson(`/api/v1.0/partner/${partnerId}/onboarding-information`, data);

export const saveInvoicingInformation = (partnerId, data) => putJson(`/api/v1.0/partner/${partnerId}/invoicing-information`, data);

export const saveReviewDetails = (partnerId, lastModified) => postJson('/api/v1.0/partner/sales-review-and-submit', { partnerId, lastModified });

export const getSalesViewDetails = (partnerId) => getJson(`/api/v1.0/partner/${partnerId}/sales-view`);
